import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { useAppLayout } from '#pplx/frontend/apps/ask/layout/primitives/AppLayoutContextSupport.js';
import { useGetCanonicalPageContext } from '#pplx/frontend/apps/ask/layout/primitives/CanonicalProviderShared.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
const NotificationUnreadDot = Dynamic(async () => {
    const { NotificationUnreadDot } = await import('#pplx/frontend/apps/ask/layout/header/NotificationUnreadDot.js');
    return { default: NotificationUnreadDot };
});
export const MobileSidebarMenuButton = ({ ariaLabel, expanded, onClick, }) => (_jsx(Button, { icon: $icon('menu-2'), variant: "text", size: "small", rounded: true, expanded: expanded, "aria-label": ariaLabel, onClick: onClick }));
export const NotificationAwareMobileSidebarMenuButton = ({ className, ...props }) => {
    const isUserLoggedIn = useIsUserLoggedIn();
    const showUnreadDot = isUserLoggedIn;
    return (_jsxs("span", { className: classNames(className, { relative: showUnreadDot }), children: [_jsx(MobileSidebarMenuButton, { ...props }), showUnreadDot && _jsx(NotificationUnreadDot, {})] }));
};
export const MobileSidebarButton = ({ className }) => {
    const { $t } = useIntl();
    const { inApp } = useGetCanonicalPageContext();
    const { isMobileSidebarOpen, setMobileSidebarOpen } = useAppLayout();
    if (inApp) {
        return null;
    }
    const ariaLabel = isMobileSidebarOpen
        ? $t({
            defaultMessage: 'Close sidebar',
            description: 'Aria label for the mobile header button when the sidebar is open',
            id: 'bb36479c09',
        })
        : $t({
            defaultMessage: 'Open sidebar',
            description: 'Aria label for the mobile header button when the sidebar is closed',
            id: 'eb6bad9983',
        });
    return (_jsx(NotificationAwareMobileSidebarMenuButton, { ariaLabel: ariaLabel, className: className, expanded: isMobileSidebarOpen, onClick: () => setMobileSidebarOpen(!isMobileSidebarOpen) }));
};
//# sourceMappingURL=MobileSidebarButton.js.map